module.exports = __webpack_public_path__ + "static/media/soundwave.e7af0555.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/soundwave.svg
// module id = 341
// module chunks = 0